import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { AgxBadge } from '@urbanx/agx.ui-components2'
import { getStatusBadgeColor } from 'utils/tasks'

interface TaskStatusCellProps {
  task: AutopilotTaskDto
}

const TaskStatusCell = ({ task }: TaskStatusCellProps) => {
  return (
    <AgxBadge
      text={task.inProgress ? 'In progress' :
          task.isPending ? 'Pending' : 'Ready to process'}
      type="colourfill"
      colour={getStatusBadgeColor(task.inProgress ?? false, task.isPending ?? false)}
      size="md"
    />
  )
}

export default TaskStatusCell
